export const INIT_ACTION_TYPES = {
  INIT_VAR_UPDATE: 'INIT_VAR_UPDATE'
};
